import { storeKey } from "../helpers/constants";
import { GTMPageView } from "../helpers/tracking";
export const updateStorage = (values) => {
    let data = Object.assign(Object.assign({}, getStore()), values);
    localStorage.setItem(storeKey, JSON.stringify(data));
};
export const getStore = () => {
    let data = localStorage.getItem(storeKey);
    return data ? JSON.parse(data) : {};
};
export const popStore = () => {
    let data = getStore();
    if (data.selectedProductId) {
        updateStorage({ selectedProductId: undefined });
        updateStorage({ productType: undefined });
        updateStorage({ startDates: undefined });
    }
    return data;
};
export const setEstimation = (context, event) => {
    context.estimation = event.data.estimation ? event.data.estimation : context.estimation;
    updateStorage({ estimation: context.estimation });
};
export const setCurrentProductIdStore = (context, event) => {
    context.selectedProductId = event.selectedProductId;
    updateStorage({ selectedProductId: context.selectedProductId });
};
export const setZipCode = (context, event) => {
    context.facilityInformation = Object.assign(Object.assign({}, context.facilityInformation), { zipcode: event.data.zipcode });
    updateStorage({ zipCode: context.facilityInformation.zipcode });
};
export const setResidenceType = (context, event) => {
    var _a, _b;
    context.facilityInformation = Object.assign(Object.assign({}, context.facilityInformation), { residenceType: event.data.residenceType });
    updateStorage({ residenceType: (_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.residenceType) !== null && _b !== void 0 ? _b : "" });
};
export const setProductType = (context, event) => {
    var _a;
    updateStorage({ productType: (_a = event === null || event === void 0 ? void 0 : event.productType) !== null && _a !== void 0 ? _a : "" });
};
export const setStartDates = (context, event) => {
    var _a;
    updateStorage({ startDates: (_a = event === null || event === void 0 ? void 0 : event.startDates) !== null && _a !== void 0 ? _a : "" });
};
const getStep = (data) => {
    let step = data.state.value;
    if (typeof step == "object")
        step = step[Object.keys(step)[0]];
    return step;
};
export const track = (context, event, data) => {
    let step = getStep(data);
    GTMPageView(mapStateToStep(step));
};
export const microTracking = (context, event, data) => {
    let step = "micro-" + getStep(data);
    GTMPageView(mapStateToStep(step));
};
export const businessTracking = (context, event, data) => {
    let step = "business-" + getStep(data);
    GTMPageView(mapStateToStep(step));
};
const mapStateToStep = (step) => {
    switch (step) {
        case "micro-initial": {
            return "micro-page-start";
        }
        case "init": {
            return "page-start";
        }
        case "movingInformation": {
            return "page-moving-information";
        }
        case "micro-vat": {
            return "micro-page-vat";
        }
        case "estimation": {
            return "page-estimation";
        }
        case "micro-estimation": {
            return "micro-page-estimation";
        }
        case "price": {
            return "page-product-selection";
        }
        case "micro-price": {
            return "micro-page-product-selection";
        }
        case "information": {
            return "page-personal-information";
        }
        case "micro-personal": {
            return "micro-page-personal-information";
        }
        case "micro-facility": {
            return "micro-page-facility-information";
        }
        case "summary": {
            return "page-summary";
        }
        case "micro-summary": {
            return "micro-page-summary";
        }
        case "business-information": {
            return "business-page-information";
        }
        case "business-summary": {
            return "business-page-summary";
        }
    }
};
